import { Counter } from "@maxhub/max-ui"

const COUNTER_VARIANTS = ["primary", "primary-contrast", "attention", "attention-contrast", "promo", "static", "static-contrast", "default", "mute", "menu"]

export const CounterExample = {
  title: "Counter",
  defaultPlatform: "ios",
  defaultZoom: 100,

  controls: [
    {
      name: "variant",
      label: "variant",
      type: "enum",
      tsType: COUNTER_VARIANTS.map((variant) => `"${variant}"`),
      default: "primary",
      options: COUNTER_VARIANTS,
    },
    {
      name: "value",
      label: "value",
      type: "text",
      tsType: "number",
      default: "1200",
    },
    {
      name: "rounded",
      label: "rounded",
      type: "boolean",
      tsType: "boolean",
      default: false,
    },
  ],

  Preview({ props }) {
    const numericValue = Number(props.value) || 0

    return (
      <Counter
        variant={props.variant}
        value={numericValue}
        rounded={props.rounded}
      />
    )
  },

  getCode(props) {
    const lines = []
    if (props.variant !== "primary") lines.push(`  variant="${props.variant}"`)
    if (props.rounded) lines.push(`  rounded`)

    const propsStr = lines.length > 0 ? "\n" + lines.join("\n") + "\n" : ""
    return `<Counter${propsStr}  value={${props.value}}
/>`
  },
}